import Vue from 'vue'
import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'

@Component
export default class UploadingJob extends Vue {
  showLoading = false

  intervalTimer: any

  async createUploadingJob () {
    try {
      const result = await this.$apollo.mutate({
        mutation: gql`
          mutation {
            createUploadingJob
          }
        `
      })
      const jobId = result.data.createUploadingJob
      const now = this.$moment().unix()
      localStorage.setItem(process.env.VUE_APP_UPLOADING_JOB_ID as string, jobId + '@' + now)
      return jobId
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  checkIfJobRunnig () {
    const jobRunning = localStorage.getItem(process.env.VUE_APP_UPLOADING_JOB_ID as string)

    if (!jobRunning) {
      return
    }

    const arr = jobRunning.split('@')

    const now = this.$moment()
    const startTime = this.$moment.unix(arr[1])

    if (startTime.add(5, 'm').isBefore(now)) {
      this.clearLoadingJob()
      return
    }

    this.showLoading = true

    this.intervalTimer = setInterval(() => {
      this.getRunningJob(arr[0])
    }, 10000)
  }

  clearIntervalTimer () {
    clearInterval(this.intervalTimer)
  }

  clearLoadingJob () {
    this.showLoading = false
    localStorage.removeItem(process.env.VUE_APP_UPLOADING_JOB_ID as string)
  }

  async getRunningJob (jobId: string) {
    try {
      const res = await this.$apollo.query({
        query: gql`
          query ($jobId: String!) {
            getUploadingJob (
              jobId: $jobId
            ) {
              m_id
              m_status
            }
          }
        `,
        variables: {
          jobId
        }
      })

      const { m_status, m_errorMessage } = res.data.getUploadingJob

      switch (m_status) {
        case 'CREATE' :
          return
        case 'UPLOADING' :
          return
        case 'SUCCESS' :
          showNotification({
            msg: '导入成功',
            type: SnackType.Info
          })
          break
        case 'FAIL' :
          showErrors([{
            message: {
              message: m_errorMessage
            }
          }])
          break
      }

      this.clearLoadingJob()
      this.clearIntervalTimer()
    } catch (e) {
      this.clearLoadingJob()
      this.clearIntervalTimer()
      showErrors(e.graphQLErrors)
    }
  }
}
